import React, { useState, useEffect, useRef } from "react";
import { AsYouType, parsePhoneNumberFromString } from "libphonenumber-js/max";

function PhoneNumberInput({
  value = "",
  inputFieldLength = 10,
  onChange,
  onEnter,
  autofocus,
  fontSize = 3,
  disabled,
  style
}) {
  const input = useRef();
  const focus = () => input.current.focus();

  const [focused, setFocused] = useState(true);
  const [formattedValue, setFormattedValue] = useState("");

  // Focus the field on load
  useEffect(() => {
    focus();
    if (value) handleChange(value);
  }, []);

  const handleChange = val => {
    const asYouType = new AsYouType("US");
    const formatted = asYouType.input(val);
    onChange(val, asYouType.getNumber());

    // remove braces when appropriate
    if (val.length <= 5 && val[0] == "(" && val[val.length - 1] !== ")") {
      const lastCursorPosition = input.current.selectionEnd;
      setFormattedValue(formatted.replace("(", "").replace(")", ""));
      input.current.selectionEnd = lastCursorPosition;
      return;
    }
    // Ignore invalid patterns, allow deleting last character
    if (!asYouType.getTemplate() && val.length > 0) {
      return;
    }

    setFormattedValue(formatted);
  };

  // To resume cursor position - Make sure to set the position
  // in handleChange and account for discrepancies
  // setCursorPosition(
  //   input.current.selectionEnd)
  // );
  //
  // useEffect(() => {
  //   input.current.selectionEnd = cursorPosition;
  // }, [formattedValue]);

  const generateStyle = (length = 10, fontSize = 3) => {
    return {
      display: "inline-block",
      border: "none",
      width: `${length + length * 0.5}ch`,
      // background: "transparent",
      background:
        "repeating-linear-gradient(90deg, dimgrey 0, dimgrey 1ch, transparent 0, transparent 1.5ch) 0 100%/100% 2px no-repeat",
      font: `${fontSize}ch gilroy`,
      letterSpacing: ".5ch",
      outline: "none"
    };
  };

  const generateStyleTest = (color = "dimgrey", length = 1, fontSize = 3) => {
    return {
      width: `${length + length * 0.5}ch`,
      background: `repeating-linear-gradient(90deg, ${color} 0, ${color} 1ch, transparent 0, transparent 1.5ch) 0 100%/100% 2px no-repeat`,
      font: `${fontSize}ch gilroy`,
      outline: "none",
      height: 2
    };
  };

  // Want little dashes under numbers only? Make this true.
  const underlineSignificantCharacters = false;
  // Want dashes under all the possible characters? Make this true.
  const underlineAllCharacters = false;
  // Want the font colors set, including for focus? Make this true.
  const useFontColors = false;

  return (
    <div className="inline-block">
      <span className="inline-block text-xl md:text-2xl">+1</span>{" "}
      <input
        type="text"
        pattern="[0-9]*"
        inputMode="numeric"
        placeholder="(000) 000-0000"
        value={formattedValue}
        style={style || underlineAllCharacters ? generateStyle(14) : {}}
        className={
          useFontColors
            ? focused
              ? "text-primary"
              : "text-gray-500"
            : " bg-transparent py-2 border-b-2 text-2xl text-center font-thin font-gilroy border-gray-500 outline-none phone-input inline-block w-9/12"
        }
        maxLength={15}
        onChange={e => handleChange(e.target.value)}
        onKeyUp={e => {
          const [v, k] = [e.target.value, e.key];
          const p = v.length - 1;
          // Move to cursor inside the braces after deleting
          // the first character after the braces
          if (k == "Backspace" && v[p] == ")") {
            console.log("mod");
            input.current.focus();
            input.current.setSelectionRange(p, p);
          }
          if (k == "Enter") {
            onEnter(v);
          }
        }}
        ref={input}
        onFocus={() => {
          setFocused(true);
        }}
        onBlur={() => {
          setFocused(false);
        }}
        disabled={disabled}
      />
      {underlineSignificantCharacters && (
        <div className="relative" style={{ bottom: 2 }}>
          {[...formattedValue].map(c => {
            return (
              <div
                className="relative float-left"
                style={generateStyleTest(
                  /[0-9]/g.test(c) ? "#26e3ba" : "transparent"
                )}
              ></div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default PhoneNumberInput;
